module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "readonly": _vm.isEdit,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.register.companyId),
      callback: function($$v) {
        _vm.$set(_vm.register, "companyId", $$v)
      },
      expression: "register.companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.cashRegisterName,
      "readonly": _vm.isEdit,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.required)); }],
      "required": ""
    },
    model: {
      value: (_vm.register.cashRegisterName),
      callback: function($$v) {
        _vm.$set(_vm.register, "cashRegisterName", $$v)
      },
      expression: "register.cashRegisterName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.username,
      "readonly": _vm.register.status !== 'NEWENTRY' && _vm.isEdit,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.required)); }],
      "required": ""
    },
    model: {
      value: (_vm.register.username),
      callback: function($$v) {
        _vm.$set(_vm.register, "username", $$v)
      },
      expression: "register.username"
    }
  })], 1), _vm._v(" "), (_vm.register.status === 'NEWENTRY' || !_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.password,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.required)); }],
      "required": ""
    },
    model: {
      value: (_vm.register.password),
      callback: function($$v) {
        _vm.$set(_vm.register, "password", $$v)
      },
      expression: "register.password"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.aesKey,
      "readonly": ""
    },
    model: {
      value: (_vm.register.aesKey),
      callback: function($$v) {
        _vm.$set(_vm.register, "aesKey", $$v)
      },
      expression: "register.aesKey"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.aesKeyCheckSum,
      "readonly": ""
    },
    model: {
      value: (_vm.register.aesKeyCheckSum),
      callback: function($$v) {
        _vm.$set(_vm.register, "aesKeyCheckSum", $$v)
      },
      expression: "register.aesKeyCheckSum"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.depAccessKey,
      "readonly": ""
    },
    model: {
      value: (_vm.register.depAccessKey),
      callback: function($$v) {
        _vm.$set(_vm.register, "depAccessKey", $$v)
      },
      expression: "register.depAccessKey"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.status,
      "readonly": ""
    },
    model: {
      value: (_vm.register.status),
      callback: function($$v) {
        _vm.$set(_vm.register, "status", $$v)
      },
      expression: "register.status"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isEdit && _vm.register.status !== 'CLOSED') ? _c('v-flex', {
    attrs: {
      "mx-3": ""
    }
  }, [_c('h3', {
    staticClass: "mt-3 mx-2"
  }, [_vm._v(_vm._s(_vm.$lang.labels.actions) + ":")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.register.status !== 'CLOSED' && _vm.register.status === 'NEWENTRY') ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateReciept('register')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.registerReciept))]) : _vm._e(), _vm._v(" "), (_vm.register.status !== 'CLOSED' && _vm.register.status === 'REGISTERED') ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateReciept('start')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.startReciept))]) : _vm._e(), _vm._v(" "), (_vm.register.status !== 'CLOSED' && _vm.register.status === 'INUSE') ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateReciept('null')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.nullReciept))]) : _vm._e(), _vm._v(" "), (_vm.register.status !== 'CLOSED' && _vm.register.status === 'INUSE') ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateReciept('end')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.endReciept))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.register.createdOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.register.createdOn),
      callback: function($$v) {
        _vm.$set(_vm.register, "createdOn", $$v)
      },
      expression: "register.createdOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.register.inUseFrom) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.inUseFrom,
      "readonly": ""
    },
    model: {
      value: (_vm.register.inUseFrom),
      callback: function($$v) {
        _vm.$set(_vm.register, "inUseFrom", $$v)
      },
      expression: "register.inUseFrom"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [(_vm.isEdit && _vm.register.modifiedOn) ? _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.register.modifiedOn),
      callback: function($$v) {
        _vm.$set(_vm.register, "modifiedOn", $$v)
      },
      expression: "register.modifiedOn"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cashRegister'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(" Close")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid && _vm.register.status !== 'NEWENTRY'
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d9068bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cashRegister/CashRegisterDetails.vue
// module id = 405
// module chunks = 35